import Form from "../form"

class FormManager {

	constructor() {
		this._init()
	}

	_init() {
		this.runDelayForm()
		this.runOneSubmitForm()
		this.runCharacterCounter()
	}

	// #region Delay Form
	runDelayForm() {
		document.querySelectorAll('form[data-action]').forEach(function (el) {
			setTimeout(function() {
				el.setAttribute('action', el.dataset.action)
				el.classList.add('active')
			}, 300)
		})
	}
	// #endregion

	// #region Once Submit Form
	runOneSubmitForm() {
		document.querySelectorAll('form[data-one-submit]').forEach(function (el) {
			el.addEventListener('submit', function(ev) {
				ev.preventDefault()
				el.classList.remove('active')
				document.body.classList.add('loading')
				
				// changed by Boto (just a tag to get back) [imput => button]
				el.querySelectorAll('button').forEach(function(el) {
					el.readOnly = true
				})
				setTimeout(function() {
					el.submit()
				}, 300)
				return false
			})
		})
	}
	// #endregion


	//#region Form with Character Counters
	runCharacterCounter() {
		document.querySelectorAll('form[data-character-counter]').forEach((el) => {
			el.querySelectorAll('[data-counter]').forEach(elCounter => {
				if(elCounter.nextElementSibling.hasAttribute('data-counter-info')){
					const infoPrevMessage = elCounter.nextElementSibling.innerText
					const maxLength = elCounter.getAttribute('maxlength')
					elCounter.addEventListener('input', () => this.onInput(elCounter, maxLength, infoPrevMessage))
					elCounter.dispatchEvent(new Event('input'))
				}
			})
		})
	}
	onInput(el, maxLength, message) {
		el.nextElementSibling.innerText = el.value.length + " / " + maxLength + " " + message
	}
	// #endregion
}

export default FormManager